import type { RouteRecordRaw } from 'vue-router';

export const groupVisitRoutes: RouteRecordRaw[] = [
  {
    path: ':groupVisitId',
    props: (route) => ({
      groupVisitId: route.params.groupVisitId,
      receiptId: route.query.receiptId,
    }),
    name: 'group-visit-detail',
    component: () => import('pages/group-visit/GroupVisitPage.vue'),
  },
];
